import { createAsyncAction } from "../../helpers/actions"
import { isLoggedIn } from "../api/isLoggedIn"
import { HEARTBEAT } from "../constants/ActionTypes"

export const checkHeartbeat = createAsyncAction(HEARTBEAT, isLoggedIn)
